import { SchemeResp } from '@/api';

/**
 * 过滤url参数
 * 剔除url中不需要的参数，将剩余的参数打平并以对象形式返回
 */
export function urlParamsFilter(schemaRes: SchemeResp): Record<string, any> {
  // 需要剔除的参数
  // 端内跳转小程序路径、retcode、retmsg、urlScheme、是否达到上限、业务类型、场景
  const filteredKeys = [
    'path',
    'retcode',
    'retmsg',
    'scheme',
    'has_reach_limit',
    'busi_type',
    'scene_type',
    'busi_info',
  ];
  const params = {};
  Object.keys(schemaRes).forEach((key: string) => {
    if (filteredKeys.includes(key)) {
      return;
    }
    const value = schemaRes[key];
    // 如果字段的类型为对象，需要将对象解构
    if (Object.prototype.toString.call(value) === '[object Object]') {
      Object.keys(value).forEach((subKey: string) => {
        params[subKey] = value[subKey] || '';
      });
      return;
    }
    params[key] = schemaRes[key] || '';
  });

  return params;
}
